export default {
  setToken(state, payload) {
    localStorage.setItem("token", payload);
    state.token = payload;
  },

  removeToken(state) {
    localStorage.removeItem("token");
    state.token = null;
  },
};
